import { render, staticRenderFns } from "./ModuloAutorizacionBase.vue?vue&type=template&id=ae41c0bc&"
import script from "./ModuloAutorizacionBase.vue?vue&type=script&lang=ts&"
export * from "./ModuloAutorizacionBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModuloAutorizacionBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ae41c0bc', component.options)
    } else {
      api.reload('ae41c0bc', component.options)
    }
    module.hot.accept("./ModuloAutorizacionBase.vue?vue&type=template&id=ae41c0bc&", function () {
      api.rerender('ae41c0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ModuloAutorizacion/ModuloAutorizacionBase.vue"
export default component.exports